"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = {
    zoom: 18,
    bearing: 180,
    pitch: 60,
    center: {
        lng: -118.2673,
        lat: 34.043,
    },
};
//# sourceMappingURL=defaults.js.map